import React, { Component } from "react";
import moment from "moment";
import ArticleItem from "./articleItem";

import constants from "../constants";
import moonIcon from "../img/icons/moon.svg";
import searchIconWhite from "../img/icons/search-white.svg";
import sunIcon from "../img/icons/sun.svg";
import "./newsGrid.scss";

class NewsGrid extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchInputText: "",
      searchQuery: "",
    };
  }

  render() {
    const articles = this.props.articles.filter((x) => {
      return x.title
        .toLowerCase()
        .includes(this.state.searchQuery.toLowerCase());
    });

    const currentHour = parseInt(moment().format("HH"), 10);

    return (
      <div className="NewsGrid">
        <div className="header">
          <img
            src={currentHour < 4 || currentHour >= 18 ? moonIcon : sunIcon}
            className="sun"
            alt="Time of day icon"
          />
          <h1>
            Good{" "}
            {(() => {
              if (currentHour >= 4 && currentHour < 12) {
                return "morning";
              } else if (currentHour >= 12 && currentHour < 18) {
                return "afternoon";
              } else {
                return "evening";
              }
            })()}
            , <strong>Jamie</strong>
          </h1>
          <div className="search">
            <input
              type="text"
              placeholder="Search for articles"
              value={this.state.searchInputText}
              onChange={(e) => {
                const newState = {
                  searchInputText: e.target.value,
                };

                if (e.target.value.length === 0) {
                  newState.searchQuery = "";
                }

                this.setState(newState);
              }}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  this.setState({
                    searchQuery: this.state.searchInputText,
                  });
                }
              }}
            />
            <div
              className="search-button"
              onClick={() => {
                this.setState({
                  searchQuery: this.state.searchInputText,
                });
              }}
            >
              <img src={searchIconWhite} alt="Search" />
            </div>
          </div>
        </div>
        <div className="articles">
          <div className="articles-column">
            {articles
              .filter((_, i) => i % 3 === 0)
              .map((article) => (
                <ArticleItem
                  article={article}
                  key={article.url}
                  onPreferencesUpdate={() =>
                    this.props.onDisplayPopup(constants.popup.preferences)
                  }
                />
              ))}
          </div>
          <div className="articles-column">
            {articles
              .filter((_, i) => i % 3 === 1)
              .map((article) => (
                <ArticleItem
                  article={article}
                  key={article.url}
                  onPreferencesUpdate={() =>
                    this.props.onDisplayPopup(constants.popup.preferences)
                  }
                />
              ))}
          </div>
          <div className="articles-column">
            {articles
              .filter((_, i) => i % 3 === 2)
              .map((article) => (
                <ArticleItem
                  article={article}
                  key={article.url}
                  onPreferencesUpdate={() =>
                    this.props.onDisplayPopup(constants.popup.preferences)
                  }
                />
              ))}
          </div>
        </div>
      </div>
    );
  }
}

export default NewsGrid;
